export default __webpack_public_path__ + "static/media/coin-img.97761583.webp";